<script setup lang="ts">
import VeeInputRows from '@/components/forms/InputRows/VeeInputRows.vue';
import FormSection from '@/components/forms/FormSection/FormSection.vue';
import { useFieldArray } from 'vee-validate';
import { type TranslatableEntity, translateEntityProperty } from '@/utils/helper';
import { EMPTY_FIELD_SIGN } from '@/components/forms/utils';
import { toRef } from 'vue';
import { useFormMode } from '@/components/forms/useFormMode';

const props = defineProps<{
  name: string;
  disabled: boolean;
  isEditable?: boolean;
  isDeletable?: boolean;
  title: string;
  tooltipText: string;
  deleteTooltipText?: string;
  disabledTooltipText?: string;
}>();

const mode = useFormMode();
const { fields } = useFieldArray<TranslatableEntity>(toRef(() => props.name));
</script>

<template>
  <FormSection :disabled="disabled">
    <v-card class="container-level-1">
      <v-card-item
        ><v-card-title>
          <h5>{{ title }}</h5>
        </v-card-title></v-card-item
      >
      <v-card-text>
        <div v-if="mode === 'details'" class="display">
          <template v-if="fields?.length">
            <v-chip v-for="field in fields" :key="field.key" class="mr-1 mb-2">
              {{ translateEntityProperty('name', field.value as TranslatableEntity) }}
            </v-chip>
          </template>
          <span v-else>{{ EMPTY_FIELD_SIGN }}</span>
        </div>
        <v-col v-else lg="6" sm="12" class="pa-0">
          <VeeInputRows
            class="input-field-max-width"
            :name="name"
            :isExtendable="!disabled"
            :deleteTooltipText="deleteTooltipText"
            :disabledTooltipText="disabledTooltipText"
            :addTooltipText="tooltipText"
            :isEditable="isEditable"
            :isDeletable="isDeletable"
            :disabled="disabled"
          />
        </v-col>
      </v-card-text>
    </v-card>
  </FormSection>
</template>
